import { useState } from "react";
import TopBar from "./components/TopBar";
import Ticker from "./components/Ticker";
import Hero from "./components/Hero";
import StatusBoard from "./components/StatusBoard";
import CollectionIndex from "./components/CollectionIndex";
import ReversalGrid from "./components/ReversalGrid";
import StatementWall from "./components/StatementWall";
import TimelineSection from "./components/TimelineSection";
import DiscussionFeed from "./components/DiscussionFeed";
import Classroom from "./components/Classroom";
import SiteFooter from "./components/SiteFooter";
import SubmitClueModal from "./components/SubmitClueModal";

export default function Home() {
  const [clueOpen, setClueOpen] = useState(false);

  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <TopBar onOpenClue={() => setClueOpen(true)} />
      <Ticker />
      <main className="w-full flex-1">
        <Hero />
        <StatusBoard />
        <CollectionIndex />
        <ReversalGrid />
        <StatementWall />
        <TimelineSection />
        <DiscussionFeed />
        <Classroom />
      </main>
      <SiteFooter />
      <SubmitClueModal open={clueOpen} onClose={() => setClueOpen(false)} />
    </div>
  );
}